import React from 'react';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../api-provider';
import { defaultPaginationConfig } from '../../../common/constants/config-defaults';
export const useFetchComments = ({ withVotes, withRatings, }) => {
    const { resourceId, ctxFields, pagination = defaultPaginationConfig, deepLink, disableResourceAutoFetching = false, } = useConfiguration();
    const { fetchComments, fetchDeepLink, fetchInteractions } = useApi((_state, actions) => ({
        fetchComments: actions.fetchComments,
        fetchDeepLink: actions.fetchDeepLink,
        fetchInteractions: actions.fetchInteractions,
    }));
    React.useEffect(() => {
        if (!disableResourceAutoFetching) {
            if (deepLink?.commentId) {
                fetchDeepLink({
                    ctxFields,
                    commentId: deepLink.commentId,
                    resourceId,
                    pagination,
                    withVotes,
                    withRatings,
                });
            }
            else {
                fetchComments({
                    resourceId,
                    pagination,
                    ctxFields,
                    withVotes,
                    withRatings,
                });
            }
        }
        fetchInteractions({ resourceId, ctxFields, withRatings, withVotes });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resourceId, deepLink?.commentId, disableResourceAutoFetching]);
};
//# sourceMappingURL=use-fetch-comments.js.map